import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ variant = 'default' }) => {
  const { language, setLanguage, t } = useLanguage();

  if (variant === 'minimal') {
    return (
      <button
        onClick={() => setLanguage(language === 'en' ? 'es' : 'en')}
        className="flex items-center gap-1.5 px-2 py-1 text-sm rounded-sm hover:bg-muted transition-colors"
        data-testid="language-selector-minimal"
      >
        <Globe className="w-4 h-4" />
        <span className="font-medium">{language === 'en' ? 'EN' : 'ES'}</span>
      </button>
    );
  }

  // Light variant for light backgrounds (auth page, landing page)
  if (variant === 'light') {
    return (
      <div className="flex flex-col items-center gap-2" data-testid="language-selector-light">
        <span className="text-xs text-gray-500 uppercase tracking-wider font-medium">{t('selectLanguage')}</span>
        <div className="flex items-center gap-1 bg-gray-100 rounded-md p-1 border border-gray-200">
          <button
            onClick={() => setLanguage('en')}
            data-testid="lang-en-btn-light"
            className={`px-4 py-2 text-sm font-semibold rounded-md transition-all duration-200 ${
              language === 'en'
                ? 'bg-navy-deep text-white shadow-md'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            English
          </button>
          <button
            onClick={() => setLanguage('es')}
            data-testid="lang-es-btn-light"
            className={`px-4 py-2 text-sm font-semibold rounded-md transition-all duration-200 ${
              language === 'es'
                ? 'bg-navy-deep text-white shadow-md'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            Español
          </button>
        </div>
      </div>
    );
  }

  // Default toggle style for dark backgrounds (sidebar)
  return (
    <div className="flex flex-col items-center gap-2" data-testid="language-selector">
      <span className="text-xs text-white/60 uppercase tracking-wider">{t('selectLanguage')}</span>
      <div className="flex items-center gap-1 bg-white/10 rounded-md p-1">
        <button
          onClick={() => setLanguage('en')}
          data-testid="lang-en-btn"
          className={`px-4 py-2 text-sm font-semibold rounded-md transition-all duration-200 ${
            language === 'en'
              ? 'bg-gold-metallic text-navy-deep shadow-md'
              : 'text-white/70 hover:text-white hover:bg-white/10'
          }`}
        >
          English
        </button>
        <button
          onClick={() => setLanguage('es')}
          data-testid="lang-es-btn"
          className={`px-4 py-2 text-sm font-semibold rounded-md transition-all duration-200 ${
            language === 'es'
              ? 'bg-gold-metallic text-navy-deep shadow-md'
              : 'text-white/70 hover:text-white hover:bg-white/10'
          }`}
        >
          Español
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector;
